// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N220","field":"styles_field__2vcJr","fieldCol":"styles_fieldCol__orisU","diffCol":"styles_diffCol__1AEHy","diff":"styles_diff__3kuUK"};